import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import classes from './PreviewFile.module.css';

const IMAGE_HEIGHT = 792;

export default function PageImage(props) {
    const { url, onRender, zoom } = props;
    const [dimensions, setDimensions] = useState({
        width: 612,
        height: IMAGE_HEIGHT,
    });

    useEffect(() => {
        const img = new Image();
        img.src = url;
        img.onload = () => {
            const dimensions = {
                width: Math.floor((img.width / img.height) * IMAGE_HEIGHT),
                height: IMAGE_HEIGHT,
            };

            setDimensions(dimensions);
            onRender(dimensions);
        };
    }, [url]);

    return (
        <div className={classes.page}>
            <img
                src={url}
                alt=""
                className="image-page"
                style={{ width: dimensions.width * zoom, height: dimensions.height * zoom }}
            />
        </div>
    );
}

PageImage.propTypes = {
    url: PropTypes.string.isRequired,
    onRender: PropTypes.func.isRequired,
    zoom: PropTypes.number.isRequired,
};
